import React from 'react';
import cn from 'classnames';
import { AppBundle } from 'api/optimalprint-sdk.d';
import styles from './StudioBundleProductItem.module.scss';

type ProductItem = AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IProductItem;

interface Props {
  item: ProductItem;
  selected: boolean;
  bundleGroupId: number;
  onClick: (productId: ProductItem) => void;
}

const StudioBundleProductItem = ({ item, selected, bundleGroupId, onClick }: Props) => (
  <div
    data-bundle-group-id={bundleGroupId}
    data-product-id={item.productId}
    data-name={item.name}
    className={cn(styles.bundleProductItem, {
      [styles.selected]: selected,
    })}
    onClick={() => onClick(item)}
  >
    {item.productId === 0 && <span>{item.name}</span>}
    {item.productId > 0 && <img src={item.iconUrl || ''} alt="" />}
  </div>
);

export default StudioBundleProductItem;
